$(function () {
	$('.lhs-menu__close').on('click', function () {
		$('.lhs-menu').removeClass('mobile-show');
	})
});